import { SxProps, Theme } from "@mui/material";
import { zoullooColors } from "../../../theme";

/**
 * Shared styles for user profile sections in menu components
 * to avoid duplication between Menu.tsx and MenuSkeleton.tsx
 */
export const getUserProfileSectionStyles = (isCollapsed: boolean): SxProps<Theme> => ({
	borderTop: `1px solid ${zoullooColors.grey[500]}`,
	py: isCollapsed ? "10px" : "20px",
	pl: isCollapsed ? "0px" : "10px",
	backgroundColor: zoullooColors.background.menu
});

export const getUserProfileContentStyles = (isCollapsed: boolean): SxProps<Theme> => ({
	display: "flex",
	alignItems: "center",
	justifyContent: isCollapsed ? "center" : "space-around",
	flexDirection: isCollapsed ? "column" : "row",
	gap: "0",
	flexGrow: 5,
	transition: "background-color 0.15s ease"
});

export const getUserProfileInnerStyles = (): SxProps<Theme> => ({
	position: "relative",
	display: "flex",
	alignItems: "center",
	gap: "7px",
	transition: "background-color 0.15s ease",
	marginLeft: "0px"
});
